import { useEffect, useState } from 'react';

// 通用的延迟渲染组件
const DelayedRender = ({
  delay = 200,
  children,
}: {
  delay?: number;
  children: React.ReactNode;
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!show) return null;

  return <>{children}</>;
};

export default DelayedRender;
